import { useRecoilState } from 'recoil';

import { isDrawerMenuOpen, isDrawerOpen } from './atoms';

export const useDrawerActions = () => {
  const [isDrawerOpenValue, setIsDrawerOpenValue] = useRecoilState(isDrawerOpen);
  const [isDrawerMenuOpenValue, setIsDrawerMenuOpenValue] = useRecoilState(isDrawerMenuOpen);

  const changeIsDrawerOpen = async () => {
    setIsDrawerOpenValue(!isDrawerOpenValue);
  };

  const setIsDrawerOpen = async (valor:boolean) => {
    setIsDrawerOpenValue(valor);
  };

  const changeIsDrawerMenuOpen = async () => {
    setIsDrawerMenuOpenValue(!isDrawerMenuOpenValue);
  };

  const setIsDrawerMenuOpen = async (valor:boolean) => {
    setIsDrawerMenuOpenValue(valor);
  };

  return {
    changeIsDrawerOpen,
    setIsDrawerOpen,
    changeIsDrawerMenuOpen,
    setIsDrawerMenuOpen
  };
};
